(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geotiff-color", [], factory);
	else if(typeof exports === 'object')
		exports["geotiff-color"] = factory();
	else
		root["geotiff-color"] = factory();
})(self, function() {
return 